export const ada = {
  initialize: () => {
    const ada = document.createElement('script');
    ada.type = 'text/javascript';
    ada.async = true;
    ada.src = 'https://static.ada.support/embed2.js';
    const s = document.getElementsByTagName('script')[0];
    s?.parentNode?.insertBefore(ada, s);

    window.adaSettings = {
      handle: 'weave',
      greeting: '6259a04d2eb1ba52dc3b345d',
    };
  },
  toggleChatBot: () => window?.adaEmbed?.toggle(),
};
